import React, { FunctionComponent } from 'react';
import { Dialog, Title } from '@liveramp/motif/core/Dialog';
import TextField from '@liveramp/motif/core/TextField';
import Checkbox from '@liveramp/motif/core/Checkbox';
import Button from '@liveramp/motif/core/Button';
import Loader from '@liveramp/motif/core/Loader';
import ButtonGroup from '@liveramp/motif/core/ButtonGroup';
import { KeyboardDatePicker } from '@material-ui/pickers';
import useEditWorkOrderModalLogic from './useEditWorkOrderModalLogic';
import styles from './styles.module.scss';

const EditWorkOrderModal: FunctionComponent = () => {
  const {
    noImpressionDataNeeded,
    activeSaveButton,
    impressions,
    endDateValue,
    noImpressionDataReason,
    onDateChangeHandler,
    onValueChange,
    onEditionSubmit,
    impressionsDataNeededHandler,
    onDialogClose,
    isDialogOpened,
    isLoading,
    editedWorkOrder
  } = useEditWorkOrderModalLogic();

  return (
    <Dialog
      className={styles.editModal}
      open={isDialogOpened}
      onClose={onDialogClose}
      onBackdropClick={onDialogClose}
      onEscapeKeyDown={onDialogClose}
      aria-labelledby="simple-dialog"
    >
      <Title className={styles.modalTitle} onClose={onDialogClose}>edit work order information</Title>
      <div className={styles.customDatePickerLabel}>campaign end date</div>
      <div className={styles.modalBody}>
        <KeyboardDatePicker
          data-test-id="edit-date-picker"
          className={styles.customDatePicker}
          autoOk
          variant="inline"
          inputVariant="outlined"
          // label="campaign end date"
          placeholder="MM/DD/YYYY"
          format="MM/DD/YYYY"
          name="endDate"
          value={endDateValue}
          InputAdornmentProps={{ position: 'end' }}
          onChange={onDateChangeHandler}
        />
        {
          editedWorkOrder.pricingModel === 'CPM'
          && (
            <>
              <TextField
                data-test-id="actual-impressions-input"
                className={styles.impressionsInput}
                id="standard-number"
                type="number"
                label="Actual Impressions"
                disabled={noImpressionDataNeeded}
                value={impressions || ''}
                name="impressions"
                onChange={onValueChange}
              />
              <div className={styles.impressionsDataNeededContainer}>
                <Checkbox
                  data-test-id="no-impressions-data-needed-checkbox"
                  checked={noImpressionDataNeeded}
                  onChange={impressionsDataNeededHandler}
                />
                <p>No impression data needed</p>
              </div>
              {noImpressionDataNeeded ? (
                <TextField
                  data-test-id="reason-why-not-needed-input"
                  className={styles.reasonWhyNotNeededInput}
                  id="outlined-multiline-default-input"
                  placeholder="Reason why not needed"
                  multiline
                  value={noImpressionDataReason || ''}
                  name="noImpressionsDataReason"
                  onChange={onValueChange}
                  rows="3"
                />
              ) : null}
            </>
          )
        }
      </div>
      <ButtonGroup className={styles.modalButtons}>
        <Button
          variant="text"
          color="primary"
          onClick={onDialogClose}
          disabled={isLoading}
          data-test-id="cancel-edit-button"
        >
          Cancel
        </Button>
        {
          isLoading
            ? <Loader size="small" />
            : (
              <Button
                color="primary"
                type="submit"
                data-test-id="submit-edit-button"
                disabled={!activeSaveButton}
                onClick={onEditionSubmit}
              >
                Save
              </Button>
            )
        }
      </ButtonGroup>
    </Dialog>
  );
};

export default EditWorkOrderModal;
